<template>
    <section class="report-pdf">
        <iframe :src="embedURL" style="width: 100%; height: 800px;" frameborder="0" scrolling="no"></iframe>

        <div class="confirm">
            <div>
                <router-link :to="{ path: 'review' }" :class="['button alternate simple back']">Review</router-link>
                <a href="/submittal-manager" class="button alternate simple back">Submittal Manager</a>
            </div>
            <div>
                <a :href="downloadURL" target="_blank" class="button">Download PDF</a>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        created() {
            this.getSubmittalInfo(this.submittalID);
        },
        methods: {

            ...mapActions('mechanical', [
                'getPDF',
                'getSubmittalInfo'
            ])

        },
        computed: {
            embedURL() {
                return `/submittal-manager/pdf?file=/actions/anvil-module/mechanical-submittal/get-pdf?id=${this.submittalID}`
            },
            downloadURL() {
                return `/actions/anvil-module/mechanical-submittal/get-pdf?id=${this.submittalID}`
            }
        },
        props: ['submittalID'],
    }
</script>
